export const REQUISICAO_AREA_LABELS = {
  ALMOXARIFADO: 'Almoxarifado',
  DRONE: 'Drone',
};

export const REQUISICAO_AREA_OPTIONS = [
  { id: 'ALMOXARIFADO', nome: 'Almoxarifado' },
  { id: 'DRONE', nome: 'Drone' },
];

export const ENDERECO_ENTREGA_TIPO_OPTIONS = [
  { id: 'RESIDENCIAL', nome: 'Residencial' },
  { id: 'OUTRO', nome: 'Outro' },
];

const ENDERECO_TIPO_LABELS = {
  RESIDENCIAL: 'Residencial',
  OUTRO: 'Outro',
};

const ENDERECO_OUTRO_OBRIGATORIOS = ['cep', 'rua', 'numero', 'cidade', 'estado'];

export const areaDoCatalogo = (catalogo, item) => {
  const found = (catalogo || []).find(
    (entry) => entry
      && entry.tipoItem === item?.tipoItem
      && String(entry.id) === String(item?.idItem)
  );
  return found?.area || null;
};

export const areasDoRascunho = (catalogo, items) => {
  const areas = new Set();
  (items || []).forEach((item) => {
    const area = areaDoCatalogo(catalogo, item);
    if (area) areas.add(area);
  });
  return [...areas];
};

export const catalogoDaArea = (catalogo, area) => {
  if (!area) return catalogo || [];
  return (catalogo || []).filter((item) => !item?.area || item.area === area);
};

export const formatEnderecoEntrega = (endereco) => {
  if (!endereco || typeof endereco !== 'object') return '';
  const tipo = ENDERECO_TIPO_LABELS[endereco.tipo] || '';
  const linha = [
    [endereco.rua, endereco.numero].filter(Boolean).join(', '),
    endereco.complemento,
    endereco.bairro,
    [endereco.cidade, endereco.estado].filter(Boolean).join(' - '),
    endereco.cep ? `CEP ${endereco.cep}` : '',
  ].filter(Boolean).join(' · ');
  if (!tipo && !linha) return '';
  if (!linha) return tipo;
  if (!tipo) return linha;
  return `${tipo}: ${linha}`;
};

export const enderecoEntregaPayload = (draft) => {
  const tipo = draft?.enderecoTipo === 'OUTRO' ? 'OUTRO' : 'RESIDENCIAL';
  if (tipo === 'RESIDENCIAL') return { tipo };
  const endereco = draft?.endereco || {};
  return {
    tipo,
    cep: endereco.cep || null,
    rua: endereco.rua || null,
    numero: endereco.numero || null,
    complemento: endereco.complemento || null,
    bairro: endereco.bairro || null,
    cidade: endereco.cidade || null,
    estado: endereco.estado || null,
  };
};

export const enderecoOutroIncompleto = (draft) => {
  if (draft?.enderecoTipo !== 'OUTRO') return false;
  const endereco = draft.endereco || {};
  return ENDERECO_OUTRO_OBRIGATORIOS.some((key) => !String(endereco[key] || '').trim());
};

export const createdRequisicoes = (data) => {
  if (Array.isArray(data)) return data.filter((item) => item && typeof item === 'object');
  if (data && typeof data === 'object') return [data];
  return [];
};
